var map = {
	"./X33-Mall_small.jpg": 908,
	"./all.svg": 909,
	"./apple-watch.png": 910,
	"./b-headphone.png": 911,
	"./coin.svg": 912,
	"./delete-btn.svg": 913,
	"./iphone-pink.png": 914,
	"./love.svg": 915,
	"./mall-banner-cn.jpg": 916,
	"./mall-banner-id.jpg": 917,
	"./mall-banner-ms.jpg": 918,
	"./mall-banner.jpg": 919,
	"./mobile-bg.jpg": 920,
	"./price-high.svg": 921,
	"./price-low.svg": 922,
	"./shopping-cart.svg": 923,
	"./star.svg": 924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;